import * as React from "react";
import * as storage from "..//helpers/storage";
import { PriceMode } from "../types";
import { getCustomer } from "../helpers/priceMode";

const PriceModeContext = React.createContext<any>(null);

interface IPriceModeProvider {
  children?: React.ReactNode;
  priceMode: PriceMode;
  customerType: string;
  setCustomerType: (c: string) => void;
}

const PriceModeContextProvider: React.FC<IPriceModeProvider> = ({
  children,
  priceMode,
  customerType,
  setCustomerType,
}) => {
  React.useEffect(() => {
    if (storage.getItem("customer_type", "default") === "default") {
      setCustomerType(getCustomer(priceMode));
    }
  }, [priceMode, setCustomerType]);

  const provided = React.useMemo(() => {
    const updateCustomerType = (c: string) => {
      storage.setItem("customer_type", c);
      setCustomerType(c);
    };
    return {
      customerType,
      updateCustomerType,
    };
  }, [customerType, setCustomerType]);

  return (
    <PriceModeContext.Provider
      value={{
        provided,
      }}
    >
      {children}
    </PriceModeContext.Provider>
  );
};

const usePriceModeContext = () => React.useContext(PriceModeContext);

export { PriceModeContextProvider, usePriceModeContext };
